"use client";

import { SessionProvider } from "@/lib/auth-react";
import { Session } from "next-auth";
import { SessionWatchdog } from "@/components/SessionWatchdog";
import ReplaySession from "@/components/replay/ReplaySession";

export function Providers({
  children,
  session,
  replayEnabled = false,
}: {
  children: React.ReactNode;
  session: Session | null;
  /** Server-resolved session-replay capture flag (site-status snapshot). */
  replayEnabled?: boolean;
}) {
  return (
    <SessionProvider session={session}>
      <SessionWatchdog />
      <ReplaySession enabled={replayEnabled} />
      {children}
    </SessionProvider>
  );
}
